import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import ContentContainer from "../common/ContentContainer";
import { useTranslation } from "react-i18next";
import { getTrending, saveQuestion, submitQuery } from "../../actions/ai-action";
import { getNewsPairs } from "../../actions/market-intelligence-action";
import { Button, Col, Form } from "react-bootstrap";
import useLoading from "../hooks/useLoading";
import Loading from "../common/Loading";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { checkSub, isPremium } from "../../utils/SubUtils";
import { SUB_TIER } from "../../Const";
import { toast } from "react-toastify";
import ObsceneWordFilter from "../common/ObsceneWordFilter";
import NonPremiumPrompt from "./NonPremiumPrompt";
import TooltipContent from "../tour/TooltipContent";
import TutorialPopup from "../help/TutorialPopup";
import useInput from "../hooks/useInput";
import AiDisclaimer from "./AiDisclaimer";
import PremiumAccess from "../common/PremiumAccess";
import Newsfeed from "./Newsfeed";
import SavedQueriesModal from "./SavedQueriesModal";
import MarketIntelligenceModal from "../MarketIntelligence/MarketIntelligenceModal";
import LockedFeature from "../MarketIntelligence/LockedFeature";
import "./ArtificialIntelligence.scss";



const MicIcon = () => (
  <img src="/images/MI/microphone.svg" alt="Mic" width="36" height="36" />
);

const SendIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.0001 4.00003L12.0001 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.00003 11L12.0001 4.00003L19 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const BotIcon = () => (
  <img src="/images/MI/ask_anything.svg" alt="Bot" width="24" height="24" style={{objectFit: 'contain'}} />
);

const TrendingIcon = () => (
  <img src="/images/MI/trending.svg" alt="Bot" width="24" height="24" style={{objectFit: 'contain'}} />
);

const MAX_TRENDING_STOCKS = 26;


const ArtificialIntelligence = (props) => {
  const {submitQuery,getTrending,saveQuestion,getNewsPairs} = props
  const { t } = useTranslation()
  const trending = useSelector((state)=>state.data.trending) || []
  const newsPairs = useSelector((state) => state.marketIntelligence.newsPairs) || [];
  const [question,setQuestion] = useState("")
  const [questionAsked,setQuestionAsked] = useState("")
  const [answer,setAnswer] = useState(null)
  const [clearInput,setClearInput] = useState(false)
  const [setLoading, bindLoading] = useLoading(false);
  const [activeTab, setActiveTab] = useState("chatbot"); // 'chatbot' or 'newsfeed'
  const subscription =
    useSelector((state) => state.auth.user.user_subscription) || {};
  const isPaid = isPremium(subscription);
  const { subPremium, subTier } = checkSub(subscription);
  const eligible = isPaid && subTier !== SUB_TIER.lite
  
  const [isListening, setIsListening] = useState(false);


  const [showSavedModal, setShowSavedModal] = useState(false);
  const [showMarketModal, setShowMarketModal] = useState(false);
  const [selectedPairId, setSelectedPairId] = useState(null);
  const [showAllTrending, setShowAllTrending] = useState(false);

  useEffect(()=>{
    setClearInput(false);
  },[question])

  const toggleListening = () => {
    if (isListening) {
      if (window.speechRecognition) {
        window.speechRecognition.stop();
      }
      setIsListening(false);
      return;
    }

    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      toast.error("Your browser does not support voice input.");
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = 'en-US';

    recognition.onstart = () => {
      setIsListening(true);
    };

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      setQuestion((prev) => (prev ? prev + " " + transcript : transcript));
      setIsListening(false);
    };

    recognition.onerror = (event) => {
      console.error("Speech recognition error", event.error);
      setIsListening(false);
      toast.error("Voice input failed. Please try again.");
    };

    recognition.onend = () => {
      setIsListening(false);
    };

    window.speechRecognition = recognition;
    recognition.start();
  };

  const submitQues = ()=>{
    if(eligible){
      if(question.length === 0) return;
      if(question.length < 10) {
        toast.error("Your query must have a minimum character of 10")
        return false
      }
      setLoading(true)
      submitQuery(question).then((res)=>{
        setClearInput(true)
        setQuestion("")
        //let boldText = res.answer.replace(/\n\*/g, '<br><br/>');
        let boldText = res.answer.replace(/\*\*(.*?)\*\*/g, (_, word) => `<strong>${word}</strong>`).replace(/\*([^*])/, '$1').replace(/\n/g, '<br><br/>');
        setAnswer(boldText)
        setQuestionAsked(res.question)
        setLoading(false)
      }).catch((err)=>{
        setLoading(false)
      })
    }
    else{
      toast.error("This feature only available to Premium and Professional plan subscribers! ")
    }
    
  }
  
  useEffect(()=>{
    getTrending()
    getNewsPairs()
  },[])

  const saveQa = ()=>{
    if (!questionAsked || !answer) return;
    saveQuestion(questionAsked,answer).then((res)=>{
      toast.success('Question saved successfully!')
    }).catch((err)=>{
      toast.error("Failed to save the question. Please try again later.");
    })
  }

  const checkEnterPressed = (event)=>{
    var code = event.keyCode || event.which;
    if(code === 13 && !event.shiftKey) { //13 is the enter keycode
      event.preventDefault();
      submitQues()
    } 
  }
  
  const handleTrendingClick = (pairId) => {
       setSelectedPairId(pairId);
       setShowMarketModal(true);
  }

  const displayedPairs = showAllTrending ? newsPairs : (newsPairs ? newsPairs.slice(0, MAX_TRENDING_STOCKS) : []);
  const trendingRows = displayedPairs.map((stock,id)=>{
    return(
      <a key={id} onClick={() => handleTrendingClick(stock.pair_id)} className="trending-chip">
         <div style={{width: 20, height: 20, borderRadius: '50%', background: '#F3F4F6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 'bold'}}>
             {stock.icon ? <img src={stock.icon} alt={stock.name} style={{width: '100%', height: '100%', borderRadius: '50%'}} /> : stock.name.charAt(0)}
         </div>
         {stock.name}
      </a>
    )
  })

  return (
    <ContentContainer url="artificial-intelligence" title={t("AI")} showExchange={true}>
      <Loading {...bindLoading}>
        <div className="ai-page-container">
            {/* Tabs */}
            <div className="ai-tabs">
                <button 
                  className={`ai-tab ${activeTab === 'chatbot' ? 'active' : ''}`}
                  onClick={() => setActiveTab('chatbot')}
                >
                  AI Chat Bot
                </button>
                <button 
                  className={`ai-tab ${activeTab === 'newsfeed' ? 'active' : ''}`}
                  onClick={() => setActiveTab('newsfeed')}
                >
                  Newsfeed
                </button>
            </div>

            {activeTab === 'chatbot' ? (
              !eligible ? (
                <LockedFeature
                  featureName="AI Chat Bot"
                  description="Unlock the power of AI Chat Bot to get answers to your trading questions."
                />
              ):
              <div className="ai-chat-content">
                {/* Input Area */}
                <div className="ai-input-wrapper">
                    <div className="ai-header">
                       <BotIcon />
                       <h3>Ask Anything</h3>
                    </div>

                    <div className="ai-input-box">
                       <ObsceneWordFilter setQuestion={setQuestion} clearInput={clearInput} inputValue={question}>
                        {(question, handleInputChange) => (
                           <textarea 
                              className="ai-textarea" 
                              placeholder="Ask about stocks, market trend, company analysis..."
                              value={question}
                              onChange={handleInputChange}
                              onKeyDown={checkEnterPressed}
                           />
                        )}
                       </ObsceneWordFilter>
                       
                       <div className="ai-input-actions">
                          <span className="ai-left-actions">
                           
                          </span>
                          <div className="ai-right-actions">
                                <button 
                                  className={`ai-action-btn ${isListening ? 'text-danger' : ''}`} 
                                  title="Voice input"
                                  onClick={toggleListening}
                                  style={{ border: 'none' }}
                                >
                                  <MicIcon />
                                </button>
                                <button 
                                  className="ai-send-btn" 
                                  onClick={() => submitQues()}
                                  disabled={!question.trim()}
                                >
                                  <SendIcon />
                                </button>
                            </div>
                       </div>
                    </div>

                    {/* Trending Stocks */}
                    <div className="trending-section">
                        <div className="trending-label">
                            <TrendingIcon />
                            Trending Stocks
                        </div>
                        <div className="trending-list">
                           {trendingRows}
                           {newsPairs && newsPairs.length > MAX_TRENDING_STOCKS && (
                               <a 
                                 onClick={() => setShowAllTrending(!showAllTrending)} 
                                 className="trending-chip" 
                                 style={{ background: 'transparent', border: 'none', color: '#007bff', cursor: 'pointer', fontWeight: 600 }}
                               >
                                   {showAllTrending ? "See Less" : "See More"}
                               </a>
                           )}
                        </div>
                    </div>
                </div>

                {/* Response Area */}
                <div className="ai-response-wrapper">
                   <h3 className="response-header">Response</h3>
                   
                   <div className="response-card">
                       {!answer ? (
                          <div className="empty-response">
                             Your answer will appear here!
                          </div>
                       ) : (
                         <>
                            <div className="response-content">
                               {questionAsked && <h6 style={{marginBottom: 16}}>Q. {questionAsked}</h6>}
                               <div dangerouslySetInnerHTML={{__html:answer}}></div>
                               <div style={{marginTop: 20, fontSize: '0.8rem', color: '#9CA3AF'}}>
                                   <AiDisclaimer />
                                </div>
                            </div>
                         </>
                       )}
                   </div>
                   <div className="response-actions">
                       <button className="btn-view-saved" onClick={() => setShowSavedModal(true)}>
                          View Saved
                       </button>
                       {answer && (
                         <button className="btn-save-response" onClick={saveQa}>
                            Save
                         </button>
                       )}
                   </div>
                </div>
              </div>
            ) : (
               <Newsfeed />
            )}
        </div>
        <SavedQueriesModal show={showSavedModal} onHide={() => setShowSavedModal(false)} />
      </Loading>
      {/* <NonPremiumPrompt showNoAccessPrompt={!eligible}></NonPremiumPrompt> */}
      <MarketIntelligenceModal 
        isOpen={showMarketModal} 
        close={() => setShowMarketModal(false)} 
        defaultPairId={selectedPairId}
      />
    </ContentContainer>
  );
};

export default connect(null,{submitQuery,getTrending,saveQuestion,getNewsPairs})(ArtificialIntelligence);
